if (!customElements.get("color-swatch")) {
  class ColorSwatch extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.optionNodes = this.querySelectorAll("[data-value]");
      this.productNodes = this.querySelectorAll("[data-product-swatch]");
      this.init();
    }

    disconnectedCallback() {
      this.optionNodes.forEach((button) =>
        button.removeEventListener("mouseenter", this.onMouseEnter.bind(this))
      );
      this.productNodes.forEach((button) =>
        button.removeEventListener("mouseenter", this.onMouseEnter.bind(this))
      );
    }

    init() {
      const productCard = this.closest(".product-card");
      this.mainImage = productCard.querySelector(
        ".product-card__image--main img"
      );

      // Check if this is product-based or variant-based swatches
      this.isProductBased = this.productNodes.length > 0;

      // DEBUG
      console.log('[ColorSwatch] Init:', {
        isProductBased: this.isProductBased,
        productNodesCount: this.productNodes.length,
        optionNodesCount: this.optionNodes.length,
        hasMainImage: !!this.mainImage,
        mainImageSrc: this.mainImage?.src
      });

      // Add event listeners based on swatch type
      if (this.isProductBased) {
        console.log('[ColorSwatch] Setting up product-based swatches');
        this.productNodes.forEach((button) =>
          button.addEventListener("mouseenter", this.onMouseEnter.bind(this))
        );
      } else {
        console.log('[ColorSwatch] Setting up variant-based swatches');
        this.optionNodes.forEach((button) =>
          button.addEventListener("mouseenter", this.onMouseEnter.bind(this))
        );
      }

      this.selected = this.querySelector('a[aria-selected="true"]');

      // Only initialize variant data for variant-based swatches
      if (!this.isProductBased) {
        this.getVariantData();
        this.initOptionSwatches();
      }
    }

    initOptionSwatches() {
      this.optionNodes.forEach((optNode) => {
        let variantImage;
        const { optionPosition, value: optionValue } = optNode.dataset;
        const variant = this.variantData.find(
          (v) =>
            v[`option${optionPosition}`] &&
            v[`option${optionPosition}`].toLowerCase() ===
              optionValue.toLowerCase()
        );
        if (variant) {
          variantImage = variant.featured_image
            ? variant.featured_image.src
            : "";
          optNode.href = `${optNode.href}?variant=${variant.id}`;
          if (variantImage) {
            optNode.setAttribute(
              "data-src",
              getSizedImageUrl(variantImage, "900x")
            );
            optNode.setAttribute("data-srcset", getSrcset(variantImage));
          }
        }
      });
    }

    onMouseEnter(e) {
      const { target } = e;

      // DEBUG
      console.log('[ColorSwatch] Mouse Enter:', {
        isProductBased: this.isProductBased,
        targetDataset: target.dataset,
        hasMainImage: !!this.mainImage
      });

      this.selected && this.selected.removeAttribute("aria-selected");
      target.setAttribute("aria-selected", true);

      // Handle product-based swatches
      if (this.isProductBased) {
        const { productSrc, productSrcset } = target.dataset;
        console.log('[ColorSwatch] Product swatch data:', { productSrc, productSrcset });

        if (this.mainImage && productSrcset) {
          console.log('[ColorSwatch] Updating image to:', productSrc);
          this.mainImage.src = productSrc;
          this.mainImage.srcset = productSrcset;
        } else {
          console.warn('[ColorSwatch] Cannot update image:', {
            hasMainImage: !!this.mainImage,
            hasSrcset: !!productSrcset
          });
        }
      } else {
        // Handle variant-based swatches
        const { src, srcset } = target.dataset;
        console.log('[ColorSwatch] Variant swatch data:', { src, srcset });

        if (this.mainImage && srcset) {
          this.mainImage.src = src;
          this.mainImage.srcset = srcset;
        }
      }

      this.selected = target;
    }

    getVariantData() {
      this.variantData =
        this.variantData || JSON.parse(this.nextElementSibling.textContent);
    }
  }
  customElements.define("color-swatch", ColorSwatch);
}
